import React from "react";
import styled from "styled-components";
import { CircleX } from "@sonder/ui/source/icons";
import { FilterTextArea } from "@sonder/ui/source/styled/fragments/GenericFilters";
import { colors } from "@sonder/ui/source/styled/theme";

const FilterTextAreaWithClearButtonWrapper = styled.div`
  display: flex;
  position: relative;
`;

const ClearWrapper = styled.div`
  color: ${colors.gray6};
  cursor: pointer;
  display: flex;
  position: absolute;
  right: 1.5rem;
  top: 50%;
  transform: translateY(-50%);

  &:hover {
    color: ${colors.gray4};
  }
`;

interface FilterTextAreaWithClearButtonProps {
  autoFocus?: boolean;
  disabled?: boolean;
  placeholder?: string;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
  onClear?: () => void;
  onFocus?: () => void;
}

export const FilterTextAreaWithClearButton = (
  props: FilterTextAreaWithClearButtonProps,
) => {
  const { onClear, ...rest } = props;

  return (
    <FilterTextAreaWithClearButtonWrapper>
      <FilterTextArea {...rest} />
      {onClear && (
        <ClearWrapper>
          <CircleX onClick={onClear} />
        </ClearWrapper>
      )}
    </FilterTextAreaWithClearButtonWrapper>
  );
};
